// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_2cMek","content":"index_content_1D4LC","image":"index_image_1QOBk","left":"index_left_3a_NV","title":"index_title_3De3Q","footer":"index_footer_2wht1"};